import styled from 'styled-components'
import Container from '../layout/Container'
import DocumentNavigation from './DocumentNavigation'

export default function DocumentContent( { contentBlocks } ) {
  return (
    <Container>
      <StyledDocumentGrid>
        <div>
          <DocumentNavigation contentBlocks={ contentBlocks } />
        </div>
        <StyledDocumentContent>
          { contentBlocks && contentBlocks.map( block => {
            if ( block.typeHandle === 'sectionHeading' ) {
              return (
                <SectionTitle
                  key={ block.id }
                  title={ block.sectionTitle }
                  anchorId={ block.anchorId }
                  id={ block.id }
                />
              )
            }
          
            if ( block.typeHandle === 'sectionBody' ) {
              return (
                <div
                  key={ block.id }
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={ { __html: block.text } }
                />
              )
            }
          
            return null
          } ) }
        </StyledDocumentContent>
      </StyledDocumentGrid>
    </Container>
  )
}

function SectionTitle( { title, anchorId, id } ) {
  return (
    <h2 id={ anchorId || id }>{ title }</h2>
  )
}

const StyledDocumentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat( 12, 1fr );

  > * {
    margin-bottom: 2rem;

    &:first-child {
      grid-column: 1 / 13;
    }

    &:last-child {
      grid-column: 1 / 13;
    }
  }

  @media ( min-width: 800px ) {
    > * {
      &:first-child {
        grid-column: 9 / 13;
        align-self: start;
        position: sticky;
        top: 7rem;
      }

      &:last-child {
        grid-row: 1;
        grid-column: 1 / 8;
      }
    }
  }
`

const StyledDocumentContent = styled.div`
  font-size: ${ p => p.theme.typo.sizes.dropped };
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-all;
  word-break: break-word;
  hyphens: auto;

  h2,
  h3,
  h4 {
    margin: 1rem 0;
    ${ p => p.theme.typo.semiBold }
    font-size: inherit;

    &:first-child {
      margin-top: 0;
    }
    
    &:last-child {
      margin-bottom: 0;
    }
  }

  h2 {
    font-size: ${ p => p.theme.typo.sizes.normal };

    &:not( :first-child ) {
      margin-top: 2rem;
    }
  }

  strong,
  b {
    ${ p => p.theme.typo.semiBold }
  }

  > div {
    > * {
      margin: 1rem 0;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  ul,
  ol {
    padding-inline-start: 1.5rem;
  }

  a {
    color: inherit;
    text-decoration-color: ${ p => p.theme.colors.green400 };
    text-underline-offset: 2px;
    text-decoration-thickness: 1px;
    transition: color .3s ease-out;

    &:hover {
      color: ${ p => p.theme.colors.green400 };
    }
  }
`
